<template>
  <div class="bg">
    <div class="banner">
      <img class="img-100" src="@/assets/img/article/banner@2x.png" alt srcset />
    </div>

    <div class="article">
      <div class="container">
        <div class="row">
          <div class="col-md-2">
            <div class="article-left">
              <div
                class="item"
                :class="activeIndex == index ? 'active' : ''"
                v-for="(item,index) in articleTab"
                :key="index"
                @click="tab(index)"
              >{{item}}</div>
            </div>
          </div>
          <div class="col-md-10">
            <div class="article-date-list">
              <div class="container-fluid date-item">
                <div class="row">
                  <div class="data-right">
                    <div class="text-cut-2 title">这里是文章标题这里是文章标题这里是文章标题这里是文章标题这里是文章标题</div>
                    <div class="time">2020-04-27 14:08</div>

                    <div
                      class="con text-indent"
                    >未来移动医疗一直坚信品质是品牌的根本，品质是客户安全的保障，公司从研发、生产到服务等相关人员，均以高度的责任感和使命感，充分洞察细节问题。</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      articleTab: ["媒体报道", "行业动态"],
      activeIndex: this.$route.query.type
    };
  },
  methods: {
    tab(index) {
      this.activeIndex = index;
      this.$router.push({
        path: "articleList",
        query: {
          type: index
        }
      });
    }
  },
  mounted(){

  }
};
</script>

<style lang='scss' scoped>
.bg {
  background-color: #f5f5f5;
}
.article {
  margin-top: 44px;

  .article-left {
    text-align: center;
    background: #fff;

    .item {
      padding: 30px 0;
      cursor: pointer;
    }

    .active {
      color: #0d9c91;
    }
  }

  .article-date-list {
    padding: 68px 55px;
    background-color: #fff;
    .date-item {
      margin-bottom: 20px;

      .img {
        width: 440px;
        height: 245px;
      }

      .data-right {
        padding: 10px;
        text-align: center;

        .title {
          font-size: 18px;
        }

        .time {
          font-size: 14px;
          color: #8d8d8d;

          padding: 20px 0 10px 0;
        }

        .con {
          font-size: 14px;
          color: #363636;
          text-align: left;
        }
      }
    }
  }
}
@media (max-width: 576px) {
  .article {
    .article-left {
      display: flex;

      .item {
        width: 50%;
        padding: 40px 0 20px 0;
      }
    }
    .article-date-list {
      padding: 20px 20px;
    }
  }
}
</style>